<div class="bn-form-group">
  <label class="form-label" for="termosContratacaoArea">Termos e condições: </label>
  <textarea class="form-control" id="termosContratacaoArea" rows="10" disabled>
    {{termosContratacao$ | async}}
  </textarea>
</div>